import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { local420Api } from "../api/local420Api";
import { Contact_Entity } from "../../entities/contact";

const contactsAdapter = createEntityAdapter<Contact_Entity>();
const initialState = contactsAdapter.getInitialState();

export const contactEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getContacts: build.query<EntityState<Contact_Entity>, void>({
      query: () => `contacts`,
      transformResponse: (responseData: Contact_Entity[]) => {
        return contactsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["contacts"],
    }),
    getContact: build.query<Contact_Entity, number>({
      query: (id) => `contacts/${id}`,
      providesTags: (result, error, id) => [{ type: "contacts", id }],
    }),
    createContact: build.mutation<Contact_Entity, Partial<Contact_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `contacts`,
      }),
      invalidatesTags: ["contacts"],
    }),
    updateContact: build.mutation<
      void,
      { id: number; body: Partial<Contact_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `contacts/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "contacts", id },
        "contacts",
      ],
    }),
    deleteContact: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `contacts/${id}`,
      }),
      invalidatesTags: ["contacts"],
    }),
  }),
});

export const {
  useGetContactQuery,
  useGetContactsQuery,
  useCreateContactMutation,
  useDeleteContactMutation,
  useUpdateContactMutation,
} = contactEndpoints;

export default contactEndpoints;
